import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
export const DEFAULT_BUTTON_AS = "button";
/**
 * Builds the classes needed for a button
 */
const buttonClassBuilder = (variant, size, disabled, className) => classNames(`eds-button`, `eds-button--${variant}`, `eds-button--${size}`, { "eds-button--disabled": disabled }, className);
const ButtonInternals = ({ children, beforeSlot, afterSlot }) => {
    return (_jsxs(_Fragment, { children: [beforeSlot && (_jsx("span", { className: "eds-button__icon-before", children: beforeSlot })), children, afterSlot && _jsx("span", { className: "eds-button__icon-after", children: afterSlot })] }));
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const Button = ({ as, children, className, disabled = false, disableRipple = false, beforeSlot, afterSlot, size = "medium", type = "button", variant = "primary", ...rest }) => {
    const ariaDisabled = disabled ? { "aria-disabled": true } : {};
    const Tag = as || DEFAULT_BUTTON_AS;
    return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    _jsxs(Tag, { disabled: disabled, className: buttonClassBuilder(variant, size, disabled, className), type: type, ...ariaDisabled, ...rest, children: [_jsx(ButtonInternals, { afterSlot: afterSlot, beforeSlot: beforeSlot, children: children }), !disableRipple && _jsx("span", { className: "eds-button__ripple" })] }));
};
export { ButtonInternals, buttonClassBuilder };
